<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addSupplier></addSupplier>
    </v-dialog>
</template>

<script>
    import addSupplier from '../../Shared/AddSupplier.vue'

    // Settings Types
    import {
        Settings
    } from '../../../store/namespace-helper'

    export default {
      name: 'add-new-supplier',
      components: {
        addSupplier
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[Settings.getters.getOpenNewSupplierDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Settings/Suppliers/AddSupplierDialog.vue